import PageWithHeaderLayout from '@/app/layouts/PageWithHeader.layout';

import OnboardingContent from './OnboardingContent';

const OnboardingPage = () => (
	<PageWithHeaderLayout showBackButton>
		<OnboardingContent />
	</PageWithHeaderLayout>
);

export default OnboardingPage;
